import React, { useContext, useEffect } from 'react'

import "./NewCardsCountdown.css"
import { getCardNewDate } from '../../Api/ConfigApp';
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import Timer from 'antd/es/statistic/Timer';
import Countdown from 'antd/es/statistic/Countdown';
import { Spin, Statistic } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const NewCardsCountdown = () => {
    const [dateNewCards,setDateNewCards] = React.useState<Date>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const {sendError} = useContext(PromiseSesionContext);

  const getDate = async () => {
    try{
      setLoading(true);

      const response = await getCardNewDate();
      // console.log(response);
      const newDate = new Date(response.date)
      console.log("todas", newDate);
      setDateNewCards(newDate)
      setLoading(false);
    }
    catch(error:any){
      setLoading(false);
    //   console.log(error)
    //   if(error?.response?.data?.message==="Catalogo no disponible"){
    //     setErrorView("bloqued")
    //   }
      sendError({type: "ERROR", data:{message:"Error al cargar la información", type:"error"}})

    }
  }

  const moreInfo = () => {


    const urlWhatsApp = `https://whatsapp.com/channel/0029VaEY2hoA89MgNiBQYU3V`;
    window.open(urlWhatsApp, '_blank'); 

  }

const onFinish = () => {
    console.log('¡El contador ha terminado! Es hora de las nuevas cartas.');
    // Aquí podrías recargar las cartas, mostrar un mensaje, etc.
    // Opcionalmente, puedes volver a llamar a getDate() si la fecha de las cartas se actualiza cíclicamente
    // getDate();
  };

  useEffect(() => {
    getDate()
  }, []);

const deadline = dateNewCards ? dateNewCards.getTime() : 0; // Si dateNewCards es undefined, usa 0 o un valor por defecto

  
  return (
    <div className="new-cards-countdown-container"> {/* Agrega una clase para estilos si es necesario */}
        <div className='new-cards-countdown-section'>
          <span className='new-cards-countdown-title'>El catálogo estará disponible con nuevas cartas en:</span>
          {loading ? <Spin indicator={<LoadingOutlined spin />} size="large" />:
          <Statistic.Timer
            value={deadline} 
            onFinish={onFinish} 
            type="countdown"
            format={`DD [día(s)] HH [hora(s)] mm [minuto(s)]`}
            className='new-cards-countdown-count'
          />}

          <button className='ProductCard-Button-plain' onClick={()=>{moreInfo()}}>Mas información</button>
        </div>

          {/* Puedes agregar un mensaje después del contador */}
          {/* <p>Prepárate para las novedades!</p> */}
    </div>
  )
}

export default NewCardsCountdown